import { memo } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface CommunicationPatientSelectionBarProps {
  selectedCount: number;
  onSendMessage: () => void;
  onClearSelection: () => void;
}

/**
 * Barra de ação em massa: envio WhatsApp fica desabilitado até haver seleção.
 */
const CommunicationPatientSelectionBar = memo(
  ({
    selectedCount,
    onSendMessage,
    onClearSelection,
  }: CommunicationPatientSelectionBarProps) => {
    const hasSelection = selectedCount > 0;

    return (
      <Paper
        variant="outlined"
        sx={{
          px: 1.5,
          py: 1.25,
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1.5,
          bgcolor: hasSelection ? "action.hover" : "background.paper",
          borderColor: hasSelection ? "primary.main" : "divider",
        }}
      >
        <Typography
          variant="body2"
          fontWeight={hasSelection ? 600 : 400}
          color={hasSelection ? "text.primary" : "text.secondary"}
        >
          {hasSelection
            ? `${selectedCount} ${
                selectedCount === 1
                  ? "paciente selecionado"
                  : "pacientes selecionados"
              }`
            : "Nenhum paciente selecionado"}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button
            variant="contained"
            size="small"
            startIcon={<WhatsAppIcon />}
            onClick={onSendMessage}
            disabled={!hasSelection}
            aria-label="Enviar mensagem via WhatsApp aos pacientes selecionados"
          >
            Enviar mensagem
          </Button>
          {hasSelection ? (
            <Button size="small" onClick={onClearSelection}>
              Limpar seleção
            </Button>
          ) : null}
        </Stack>
      </Paper>
    );
  },
);

CommunicationPatientSelectionBar.displayName =
  "CommunicationPatientSelectionBar";

export default CommunicationPatientSelectionBar;
